import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
export const GlobalToaster = () => {
    const location = useLocation();
    const { isDark } = useTheme();
    // Não exibir toast global nas páginas de lançamento externo pois elas têm seu próprio Toaster
    if (location.pathname.includes('/obras/lancamento/')) {
        return null;
    }
    return (_jsx(Toaster, { position: "top-center", gutter: 12, containerStyle: {
            top: 10,
            zIndex: 9999,
        }, toastOptions: {
            duration: 4000,
            style: {
                background: isDark ? 'var(--color-gray-800)' : 'white',
                color: isDark ? 'var(--color-gray-100)' : 'var(--color-gray-700)',
                border: isDark ? '1px solid var(--color-gray-700)' : '1px solid var(--color-gray-200)',
                borderRadius: '12px',
                boxShadow: isDark
                    ? '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2)'
                    : '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                padding: '16px',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                maxWidth: '420px',
                minWidth: '320px',
                pointerEvents: 'auto',
                userSelect: 'none',
            },
            success: {
                duration: 4000,
                iconTheme: {
                    primary: '#10b981',
                    secondary: isDark ? '#1a1a1a' : 'white',
                },
                style: {
                    border: isDark
                        ? '1px solid rgba(34, 197, 94, 0.3)'
                        : '1px solid rgba(34, 197, 94, 0.2)',
                    background: isDark
                        ? 'linear-gradient(135deg, #064e3b 0%, #065f46 100%)'
                        : 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
                    color: isDark ? '#d1fae5' : 'var(--color-gray-700)',
                },
            },
            error: {
                duration: 5000,
                iconTheme: {
                    primary: '#ef4444',
                    secondary: isDark ? '#1a1a1a' : 'white',
                },
                style: {
                    border: isDark
                        ? '1px solid rgba(239, 68, 68, 0.3)'
                        : '1px solid rgba(239, 68, 68, 0.2)',
                    background: isDark
                        ? 'linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%)'
                        : 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                    color: isDark ? '#fecaca' : 'var(--color-gray-700)',
                },
            },
            loading: {
                duration: Infinity,
                iconTheme: {
                    primary: '#ff7336',
                    secondary: isDark ? '#1a1a1a' : 'white',
                },
                style: {
                    border: isDark
                        ? '1px solid rgba(255, 137, 81, 0.3)'
                        : '1px solid rgba(255, 137, 81, 0.2)',
                    background: isDark
                        ? 'linear-gradient(135deg, #b33200 0%, #d63c00 100%)'
                        : 'linear-gradient(135deg, #f5f5f5 0%, #e5e5e5 100%)',
                    color: isDark ? '#d4d4d4' : 'var(--color-gray-700)',
                },
            },
        } }));
};
